const carRental = {
  carRental: "Location de voiture", // translated
  carRentals: "Location de voitures", // translated
  pickUpPoint: "Point de retrait", // translated
  dropOffPoint: "Point de dépôt", // translated
  pickUpDate: "Date de ramassage", // translated
  dropOffDate: "Date de dépôt", // translated
  pickUp: "Ramasser", // translated
  dropOff: "Déposer", // translated
  edit: "Modifier", // translated
  fuelPolicy: "Politique de carburant", // translated
  pickUpLocation: "Lieu de ramassage", // translated
  mileage: "Kilométrage", // translated
  transmission: "Transmission", // translated
  airCondition: "Climatisation", // translated
  minimumAge: "Âge minimum", // translated
  maximumAge: "Âge maximum", // translated
  providerAddress: "Adresse du fournisseur", // translated
  providerPhone: "Téléphone du fournisseur", // translated
  driverInfo: "Informations sur le conducteur", // translated
  driversInfo: "Informations sur le conducteur", // translated
  differentDropOff: "Dépose à un endroit différent", // translated
  maxPassengers: "Nombre maximum de passagers", // translated
  budget: "Budget", // translated
  provider: "Fournisseur", // translated
  carModel: "Modèle de voiture", // translated
  numOfDoors: "Nombre de portes", // translated
  fuelType: "Type de carburant", // translated
  driverAge: "Âge du conducteur", // translated
  workingHours: "Heures d'ouverture", // translated
  driverNationality: "Nationalité du conducteur", // translated
  carRentalRate: "Tarif de location de voiture", // translated
  dueNow: "Pour tout de suite", // translated
  duePickUp: "À payer à la prise en charge", // translated
  toViewOfferPDF: "Pour consulter un document PDF contenant toutes les conditions de location de cette offre, veuillez", // translated
  toViewTermsAndCondPDF: "Pour consulter les conditions générales de CARNECT applicables, veuillez", // translated
};


export default carRental;
